import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useOfferingStatusStyles } from './styles';
import { ReactComponent as InfoSVG } from './assets/info.svg';

interface OfferingStatusProps {
  isFullyBooked: boolean;
  isBooked: boolean;
}

const OfferingStatus = ({ isFullyBooked, isBooked }: OfferingStatusProps) => {
  const classes = useOfferingStatusStyles({ isFullyBooked, isBooked });
  const { t } = useTranslation();

  if (!isFullyBooked && !isBooked) {
    return null;
  }

  return (
    <Box className={classes.statusBanner}>
      <InfoSVG />
      <span>
        {isFullyBooked
          ? t('v2.global.label_eventFullyBooked')
          : t('v2.global.label_eventBooked')}
        .{' '}
        <span className={classes.statusCta}>
          {t('v2.global.button_label_seeEventDetails')}
        </span>
      </span>
    </Box>
  );
};

export default OfferingStatus;
